<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="mx-auto col-lg-12 col-12">
        <div class="mt-4 card card-body">
          <Form 
          titlePage="Edit Subscription"
          subtitlePage="Edit a Subscription"
          submitButtonName="Update Subscription"
          :onSubmit="onSubmit"
          :recordProps="record"
          :invoiceProps="invoice" />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "./Form.vue";
import SubscriptionService from "@/services/subscriptions.service.js";
import InvoiceService from "@/services/invoices.service.js";
import { ref } from 'vue';
import { toast } from 'vue3-toastify';

const toastId = ref('');


export default {
  name: "RecapEdit",
  components: {
    Form
  },

  data() {
    return {
      record: {},
      invoice: {},
    };
  },
  mounted(){
    this.getRecord()
  },
  methods: {
    showLoading(){
      toastId.value = toast.loading('Please wait...');
    },
    hideLoading(){
      setTimeout(() => {
        toast.remove(toastId.value)
      }, 1000); 
    },
    showSuccess(){
      toast.update(toastId.value, {
        render: "Update Successfully",
        closeOnClick: true,
        closeButton: true,
        type: 'success',
        isLoading: false,
        autoClose: 3000
      });
      
      setTimeout(() => {
        this.$router.replace('/subscriptions')
      }, 1000);     
    },
    showFailed(e){
      toast.update(toastId.value, {
        render: e,
        closeOnClick: true,
        closeButton: true,
        type: 'error',
        isLoading: false,
        autoClose: 3000
      });
    },
    getRecord(){
      this.showLoading()

      SubscriptionService.get(this.$route.params.id).then(e => {
        this.record = e.data.subscribe_data
        this.getInvoice()
        this.hideLoading()
      }).catch(e => {
        this.showFailed(e.response.data.code_message)           
      });
    },
    getInvoice(){
      InvoiceService.get(this.record.invoice_id).then(e => {
        this.invoice = e.data.invoice_data
        console.log(this.invoice)
        // this.record = e.data.subscribe_data
      }).catch(e => {
        console.log(e)
        // this.showFailed(e.response.data.code_message)           
      });
    },
    onSubmit(data){
      this.showLoading()
      
      SubscriptionService.update(data, this.$route.params.id).then(() => {
        this.showSuccess()
      }).catch(e => {
        this.showFailed(e.response.data.code_message)           
      });

    }
  }
};
</script>
